import { useEffect, useMemo } from "react";
import * as Yup from "yup";

import { useLazyPremiseAreaQuery } from "apis/PremiseArea";
import { useLazyZoneQuery } from "apis/Zone";
import { useLazyBlockQuery } from "apis/Block";
import { useLazyApplicationTypeQuery } from "apis/ApplicationType";
import { useLazyUtilityQuery } from "apis/Utility";
import { useLazyMeasurementTypeQuery } from "apis/MeasurementType";
import { useLazyLocationQuery } from "apis/Location";

import {
  // ACCESSORIES,
  // ACCESSORIES,
  // APPLICANT_TYPE,
  // APPLICATION_STATUS,
  APPLICATION_TYPE,
  BLOCK,
  BUILDING,
  CHARGES,
  CITY,
  FLOOR,
  // MEASUREMENT_TYPE,
  // OCCUPANCY_TYPE,
  PINCODE,
  // PREMISE_AREA,
  // PREMISE_TYPE,
  ROAD,
  SOURCE_OF_POWER,
  TARIFF,
  UTILITY,
  // UTILITY_TYPE_MAPPING,
  ZONE,
} from "tagTypes";
import { useLazyGetQuery } from "slices/api";
import { masterDataIds } from "common/constant";
import {
  chargeModule,
  chargeTypes,
  powerApplicationTypes,
  tariffTypes,
} from "common/enums";

const RECORDS_PER_PAGE = 10;

export const useMasterData = ({
  selectedTypeId,
  premiseAreaId,
  zoneId,
  blockId,
  buildingId,
  t,
}) => {
  const [
    getPremiseAreas,
    { data: { data: { items: premiseAreas } = {} } = {} },
  ] = useLazyPremiseAreaQuery();

  const [getZones, { data: { data: zones } = {} }] = useLazyZoneQuery();

  const [getBlocks, { data: { data: blocks } = {} }] = useLazyBlockQuery();

  const [getUtilities, { data: { data: { items: utilities } = {} } = {} }] =
    useLazyUtilityQuery();

  const [getCities, { data: { data: { items: cities } = {} } = {} }] =
    useLazyLocationQuery();

  const [
    getTableData,
    { data: { data: tableData } = {}, isLoading, isFetching },
  ] = useLazyGetQuery();

  const [
    getMeasurementTypes,
    { data: { data: { items: measurementTypes } = {} } = {} },
  ] = useLazyMeasurementTypeQuery();

  const [
    getApplicationTypes,
    { data: { data: { items: applicationTypes } = {} } = {} },
  ] = useLazyApplicationTypeQuery();

  useEffect(() => {
    try {
      switch (selectedTypeId) {
        case masterDataIds["Zone"]:
          getPremiseAreas();
          break;
        case masterDataIds["Block"]:
          getPremiseAreas();
          getZones(premiseAreaId);
          break;
        case masterDataIds["Building"]:
          getPremiseAreas();
          getZones(premiseAreaId);
          getBlocks(zoneId);
          break;
        case masterDataIds["PinCode"]:
          getCities();
          break;
        case masterDataIds["Utility Application Type Mapping"]:
          getApplicationTypes();
          getUtilities();
          break;
        case masterDataIds["Accessories"]:
          getMeasurementTypes();
          break;
      }
    } catch (error) {}
  }, [selectedTypeId, premiseAreaId, zoneId]);

  const masterData = useMemo(
    () => [
      // {
      //   label: "Applicant Type",
      //   id: masterDataIds["Applicant Type"],
      //   endpoint: "/applicant-type",
      //   tags: [APPLICANT_TYPE],
      //   isPagination: true,
      //   dependedFieldsForAddData: [
      //     {
      //       field: "Applicant Type",
      //       fieldName: "name",
      //     },
      //   ],
      // },
      // {
      //   label: "Occupancy Type",
      //   id: masterDataIds["Occupancy Type"],
      //   endpoint: "/occupancy-type",
      //   tags: [OCCUPANCY_TYPE],
      //   isPagination: true,
      //   dependedFieldsForAddData: [
      //     {
      //       field: "Occupancy Type",
      //       fieldName: "name",
      //     },
      //   ],
      // },
      // {
      //   label: "Premise Type",
      //   id: masterDataIds["Premise Type"],
      //   endpoint: "/premise-type",
      //   tags: [PREMISE_TYPE],
      //   isPagination: false,
      //   dependedFieldsForAddData: [
      //     {
      //       field: "Premise Type",
      //       fieldName: "name",
      //     },
      //   ],
      // },
      {
        label: "Application Type",
        id: masterDataIds["Application Type"],
        endpoint: "/application-type",
        tags: [APPLICATION_TYPE],
        isPagination: true,
        dependedFieldsForAddData: [
          {
            field: "Application Type",
            fieldName: "name",
          },
        ],
      },
      // {
      //   label: "Premise Area",
      //   id: masterDataIds["Premise Area"],
      //   endpoint: "/premise-area",
      //   tags: [PREMISE_AREA],
      //   isPagination: true,
      //   dependedFieldsForAddData: [
      //     {
      //       field: "Premise Area",
      //       fieldName: "name",
      //     },
      //   ],
      // },
      {
        label: "Zone",
        id: masterDataIds["Zone"],
        endpoint: `/premise-area/${premiseAreaId}/zone`,
        updateDataEndpoint: "/zone",
        tags: [ZONE],
        isPagination: false,
        dependedFieldsForAddData: [
          {
            field: "Zone",
            fieldName: "name",
          },
          {
            field: "Premise Area",
            fieldName: "premiseAreaId",
            fieldKey: "premiseArea.id",
            options: premiseAreas || [],
          },
        ],
        dependedFieldsForGetData: [
          {
            fieldLabel: "Premise Area",
            fieldKey: "premiseAreaId",
            options: premiseAreas || [],
          },
        ],
      },
      // {
      //   label: "Application Status",
      //   id: masterDataIds["Application Status"],
      //   endpoint: "/application-status",
      //   tags: [APPLICATION_STATUS],
      //   isPagination: false,
      //   dependedFieldsForAddData: [
      //     {
      //       field: "Application Status",
      //       fieldName: "name",
      //     },
      //   ],
      // },
      {
        label: "Block",
        id: masterDataIds["Block"],
        endpoint: `/zone/${zoneId}/block`,
        updateDataEndpoint: "/block",
        tags: [BLOCK],
        isPagination: false,
        dependedFieldsForAddData: [
          {
            field: "Block",
            fieldName: "name",
          },
          {
            field: "Zone",
            fieldName: "zoneId",
            fieldKey: "zone.id",
            options: zones || [],
          },
        ],
        dependedFieldsForGetData: [
          {
            fieldLabel: "Premise Area",
            fieldKey: "premiseAreaId",
            options: premiseAreas || [],
          },
          { fieldLabel: "Zone", fieldKey: "zoneId", options: zones || [] },
        ],
      },
      {
        label: "Building",
        id: masterDataIds["Building"],
        endpoint: `block/${blockId}/building`,
        updateDataEndpoint: "/building",
        isPagination: false,
        tags: [BUILDING],
        dependedFieldsForAddData: [
          {
            field: "Building",
            fieldName: "name",
          },
          {
            field: "Block",
            fieldName: "blockId",
            fieldKey: "block.id",
            options: blocks || [],
          },
        ],

        dependedFieldsForGetData: [
          {
            fieldLabel: "Premise Area",
            fieldKey: "premiseAreaId",
            options: premiseAreas || [],
          },
          { fieldLabel: "Zone", fieldKey: "zoneId", options: zones || [] },
          {
            fieldLabel: "Block",
            fieldKey: "blockId",
            options: blocks || [],
          },
        ],
      },
      // {
      //   label: "Document Category",
      // id: masterDataIds["Document Category"],
      //   endpoint: "/document-category",
      //   editComponent: "documentType",
      // },
      // {
      //   label: "Document Type",
      // id: masterDataIds["Document Type"],
      //   endpoint: "/document-type",
      //   columns: [
      //     {
      //       title: "Document Type",
      //       field: "name",
      //     },
      //     {
      //       title: "Document Category",
      //       field: "documentCategory",
      //     },
      //   ],
      // },
      {
        label: "Floor",
        id: masterDataIds["Floor"],
        endpoint: "/floor",
        tags: [FLOOR],
        isPagination: false,
        dependedFieldsForAddData: [
          {
            field: "Floor",
            fieldName: "name",
          },
        ],
      },
      {
        label: "City",
        id: masterDataIds["City"],
        endpoint: "/city/location",
        tags: [CITY],
        updateDataEndpoint: "/city",
        isPagination: true,
        isQueryParam: true,
        dependedFieldsForAddData: [
          {
            field: "City",
            fieldName: "name",
          },
        ],
      },
      {
        label: "Pincode",
        id: masterDataIds["PinCode"],
        endpoint: "/pincode/location",
        updateDataEndpoint: "/pincode",
        tags: [PINCODE],
        isQueryParam: true,
        isPagination: false,
        dependedFieldsForAddData: [
          {
            field: "Pincode",
            fieldName: "pinCode",
            type: "number",
          },
          {
            field: "City",
            fieldName: "cityId",
            fieldKey: "city.id",
            options: cities || [],
          },
        ],
        validation: {
          pinCode: Yup.string()
            .matches(/^\d{6}$/, t("Please enter valid pincode"))
            .required(t("Pincode is required")),
          cityId: Yup.string().required(t("City is required")),
        },
        columns: [
          {
            title: t("Pincode"),
            field: "pinCode",
          },
          {
            title: t("City"),
            field: "city.name",
          },
        ],
      },
      // {
      //   label: "Measurement Type",
      // id: masterDataIds["Measurement Type"],
      //   isPagination: true,
      //   endpoint: "/measurement-type",
      //   tags: [MEASUREMENT_TYPE],
      //   dependedFieldForAddData: [
      //     {
      //       field: "Measurement Type",
      //       fieldName: "name",
      //     },
      //   ],
      // },
      {
        label: "Road",
        id: masterDataIds["Road"],
        endpoint: "/road",
        tags: [ROAD],
        isPagination: false,
        dependedFieldsForAddData: [
          {
            field: "Road",
            fieldName: "name",
          },
        ],
      },
      {
        label: "Tariff",
        id: masterDataIds["Tariff"],
        endpoint: "/tariff",
        tags: [TARIFF],
        isPagination: false,
        dependedFieldsForAddData: [
          {
            field: "Tariff",
            fieldName: "name",
          },
        ],
      },
      {
        label: "Source of Power",
        id: masterDataIds["Source Of Power"],
        endpoint: "/source-of-power",
        tags: [SOURCE_OF_POWER],
        dependedFieldsForAddData: [
          {
            field: "Source of Power",
            fieldName: "name",
          },
        ],
      },
      {
        label: "Utility",
        id: masterDataIds["Utility"],
        endpoint: "/utility",
        tags: [UTILITY],
        isPagination: true,
        dependedFieldsForAddData: [
          {
            field: "Utility",
            fieldName: "name",
          },
        ],
      },
      // {
      //   label: "Utility Application Type Mapping",
      //   id: masterDataIds["Utility Application Type Mapping"],
      //   isPagination: true,
      //   endpoint: "/utility-application-type-mapping",
      //   tags: [UTILITY_TYPE_MAPPING],
      //   dependedFieldsForAddData: [
      //     {
      //       field: "Application Type",
      //       fieldName: "applicationTypeId",
      //       options: applicationTypes || [],
      //     },
      //     {
      //       field: "Utility",
      //       fieldName: "utilityId",
      //       options: utilities || [],
      //     },
      //   ],
      // },
      // {
      //   label: "Accessories",
      //   id: masterDataIds["Accessories"],
      //   endpoint: "/accessories",
      //   tags: [ACCESSORIES],
      //   isPagination: false,
      //   dependedFieldsForAddData: [
      //     {
      //       field: "SAP Number",
      //       fieldName: "sapNumber",
      //     },
      //     {
      //       field: "Name",
      //       fieldName: "name",
      //     },
      //     {
      //       field: "Measurement Type",
      //       fieldName: "measurementTypeId",
      //       fieldKey: "measurementType.id",
      //       options: measurementTypes || [],
      //     },
      //     {
      //       field: "Basic Unit Rate",
      //       fieldName: "basicUnitRate",
      //       type: "number",
      //     },
      //     {
      //       field: "GST",
      //       fieldName: "gst",
      //       type: "number",
      //     },

      //     {
      //       field: "Admin Charges",
      //       fieldName: "adminCharges",
      //       type: "number",
      //     },
      //     {
      //       field: "GST On Admin Charges",
      //       fieldName: "gstOnAdminCharges",
      //       type: "number",
      //     },
      //   ],
      //   columns: [
      //     {
      //       title: t("Accessories"),
      //       field: "name",
      //     },
      //     {
      //       title: t("Measurement Type"),
      //       field: "measurementType.name",
      //     },
      //     {
      //       title: t("Unit Rate"),
      //       field: "unitRate",
      //     },
      //     {
      //       title: t("Final Cost"),
      //       field: "finalCost",
      //     },
      //   ],
      // },
      {
        label: "Charge",
        id: masterDataIds["Charge"],
        endpoint: "/charge",
        tags: [CHARGES],
        isPagination: false,

        dependedFieldsForAddData: [
          {
            field: "Charge Type",
            fieldName: "chargeTypeId",
            fieldKey: "chargeType.id",
            options: chargeTypes,
            getOptionLabel: (option) => option.label,
            getOptionValue: (option) => option.value,
          },
          {
            field: "Tariff Type",
            fieldName: "tariffTypeId",
            fieldKey: "tariffType.id",
            options: tariffTypes,
            getOptionLabel: (option) => option.label,
            getOptionValue: (option) => option.value,
          },
          {
            field: "Charge Module",
            fieldName: "module",
            fieldKey: "module.id",
            options: chargeModule,
            getOptionLabel: (option) => option.label,
            getOptionValue: (option) => option.value,
          },
          {
            field: "Application Type",
            fieldName: "applicationTypeId",
            fieldKey: "applicationType.id",
            options: powerApplicationTypes,
            getOptionLabel: (option) => option.label,
            getOptionValue: (option) => option.value,
          },
          {
            field: "Min Value",
            fieldName: "minValue",
            type: "number",
          },
          {
            field: "Max Value",
            fieldName: "maxValue",
            type: "number",
          },
          {
            field: "Rate",
            fieldName: "rate",
            type: "number",
          },
          {
            field: "CGST",
            fieldName: "cgst",
            type: "number",
          },
          {
            field: "SGST",
            fieldName: "sgst",
            type: "number",
          },
          {
            field: "IGST",
            fieldName: "igst",
            type: "number",
          },
          {
            field: "Temporary Connection",
            fieldName: "isTemporaryConnection",
            isCheckBox: true,
          },
        ],
        columns: [
          {
            title: t("Charge Type"),
            field: "chargeType.name",
          },
          {
            title: t("Tariff Type"),
            field: "tariffType.name",
          },
          {
            title: t("Min Value"),
            field: "minValue",
          },
          {
            title: t("Max Value"),
            field: "maxValue",
          },
          {
            title: t("Rate"),
            field: "rate",
          },
          {
            title: t("CGST"),
            field: "cgst",
          },
          {
            title: t("SGST"),
            field: "sgst",
          },
          {
            title: t("IGST"),
            field: "igst",
          },
        ],
      },
    ],
    [
      premiseAreas,
      zones,
      blocks,
      utilities,
      cities,
      tableData,
      measurementTypes,
      applicationTypes,
      blockId,
      zoneId,
      premiseAreaId,
      buildingId,
      t,
    ]
  );

  const selectedMasterDataType = useMemo(
    () => masterData.find(({ id }) => id === selectedTypeId),
    [selectedTypeId, masterData]
  );

  const {
    endpoint,
    tags,
    label,
    columns: selectedMasterDataTypeColumns,
  } = selectedMasterDataType;

  useEffect(() => {
    if (!selectedMasterDataType.isPagination) {
      getTableData(
        {
          endpoint: endpoint,
          tags: tags,
        },
        true
      );
    }
  }, [selectedMasterDataType]);

  const serverSidePaginationConfig = useMemo(
    () => ({
      endpoint: endpoint,
      tags: tags,
    }),
    [selectedMasterDataType]
  );

  const columns = useMemo(
    () => selectedMasterDataTypeColumns ?? [{ title: label, field: "name" }],
    [selectedMasterDataType]
  );

  const baseTableProps = useMemo(
    () =>
      selectedMasterDataType.isPagination
        ? {
            pageSize: RECORDS_PER_PAGE,
            paginationType: "serverSide",
            serverSidePaginationConfig: serverSidePaginationConfig,
          }
        : { data: tableData, pageSize: RECORDS_PER_PAGE },
    [selectedMasterDataType]
  );

  return {
    selectedMasterDataType,
    columns,
    baseTableProps,
    masterData,
    isLoading: isLoading || isFetching,
  };
};
